<template>
    <section>
        <div class="left">
            <h2 v-translate>Kontakty</h2>
        </div>
        <div class="right">
            <div class="field_left">
                <!-- hidden fake so that browsers do not autocomplete real inputs with values -->
                <input id="email" name="email" type="text" style="display: none">
                <text-input
                    id="real-email"
                    v-model="subscriber.email"
                    :disabled="!isEditable"
                >
                  <translate class="translate">E-mail</translate>
                </text-input>
            </div>
            <div class="field_right">
                <text-input
                    id="telefon"
                    v-model="subscriber.phone"
                    :disabled="!isEditable"
                >
                  <translate class="translate">Telefon</translate>
                </text-input>
            </div>
            <div class="field_left">
                <text-input
                    id="ulice"
                    v-model="subscriber.address.street"
                    :disabled="!isEditable"
                >
                  <translate class="translate">Ulice a č. p.</translate>
                </text-input>
                <text-input
                    id="mesto"
                    v-model="subscriber.address.town"
                    :disabled="!isEditable"
                >
                  <translate class="translate">Město</translate>
                </text-input>
            </div>
            <div class="field_right">
                <text-input
                    id="psc"
                    v-model="subscriber.address.postal_code"
                    :disabled="!isEditable"
                >
                  <translate class="translate">PSČ</translate>
                </text-input>
                <select-box id="stat"
                            v-model="subscriber.address.country"
                            :options="countries"
                            ref="statref"
                            :disabled="!isEditable"
                ><translate class="translate">Stát</translate>
                </select-box>
            </div>
        </div>
    </section>
</template>

<script>
	import TextInput from "@/components/common/TextInput"

	import formFilterData from "@/components/mixins/form-filter-data"

	export default {
		name: "Contact",
		components: {
			TextInput
		},
    mixins: [formFilterData],
		props: {
			subscriber: Object,
      isEditable: Boolean,
		}
	}
</script>



// WEBPACK FOOTER //
// src/components/views/subscribers/settings/Contact.vue